import { hetsApi } from "@/apis/interceptor"
import { ILocationResponse, IPaginationParamV2, IResponse } from "@/types"

export const locationsService = {
  getLocations: async (params: IPaginationParamV2): Promise<IResponse<ILocationResponse>> => {
    const response = await hetsApi.get<IResponse<ILocationResponse>>("/v1/locations", { params })
    return response.data
  },
}
